export const subscription = {
  subscriptions: 'Abonimet',
  plan: 'Plan',
  whatsappPlan: 'Plan WhatsApp',
  addOns: 'Shtesat',
  billingDetails: 'Detajet e Faturimit',
  invoices: 'Faturat',
  wa1Reminder: 'Kujtesa e 1-te në WhatsApp',
  wa2Reminder: 'Kujtesa e 2-te në WhatsApp',
  waRenewApi: 'Rinovo API në WhatsApp',
  waCheckUsageApi: 'Kontrollo API-n e Përdorimit në WhatsApp',
  waResetUsageApi: 'Rivendos API-n e Përdorimit në WhatsApp',
  waExceedUsageApi: 'Kalimi i Përdorimit në WhatsApp',
  waGetBotsInThisAccount: 'Merr botët në këtë llogari në WhatsApp',
  appTooltip: {
    TOOLTIP_PLAN_HEADING: 'Kemi çmimet më të arsyeshme për të gjitha nevojat tuaja.',
    TOOLTIP_WHATSAPP_PLAN_HEADING: 'Plan WhatsApp',
    TOOLTIP_ADDS_ON_HEADING: 'Bleni pako shtesash për mesazhe dhe botë me markë të bardhë',
    TOOLTIP_ADDS_ON_MESSAGE: 'Nëse keni arritur limitin mujor të mesazheve, mund të blini pako shtesash.',
    TOOLTIP_SUBSCRIPTION_HEADING: 'Kontrollo detajet aktuale të abonimit tuaj',
    TOOLTIP_HORIZONTAL_BAR: 'Kontrolloni çmimet tona mujore ose vjetore nga 3K deri në 500K mesazhe duke lëvizur shiritin nga majtas në djathtas.',
    TOOLTIP_BILLING_ADDRESS_HEADING: 'Përditësoni detajet e faturimit për faturimin.',
    TOOLTIP_INVOICES_HEADING: 'Kontrolloni faturat tuaja të mëparshme.',
    TOOLTIP_INVOICES_ACTION: 'Klikoni për të marrë faturën në llogarinë tuaj të emailit'
  },
  currentPlan: {
    seeHowToUse: 'Shih se si të përdoret',
    help: 'Ndihmë',
    downgradeRequest1: 'Keni bërë një kërkesë për zvogëlim të planit tuaj në',
    downgradeRequest2: 'mesazhe. Ju lutemi, shënim, Plani juaj do të zvogëlohet në fund të ciklit të tanishëm të faturimit',
    downgradeRequest3: 'Mund të shijoni',
    downgradeRequest4: 'shërbimet deri atëherë.',
    downgradeRequestMaster1: 'Keni bërë një kërkesë për zvogëlimin e ',
    downgradeRequestMaster2: ' planit tuaj në',
    downgradeRequestMaster3: ' biseda. Ju lutemi, shënim, Plani juaj do të zvogëlohet në fund të ciklit të tanishëm të faturimit',
    downgradeRequestMaster4: 'Mund të shijoni ',
    downgradeRequestMaster5: 'shërbimet deri atëherë.',
    active: 'Aktiv',
    inactive: 'Joaktive',
    month: 'muaj',
    year: 'vit',
    messagePack: 'Pako Mesazhesh',
    king: 'Mbreti',
    baby: 'Bebja',
    whatsapp: 'WhatsApp',
    youAreOn: 'Jeni në',
    plan: 'plan',
    totalMessagesLimit: 'Limiti Total i Mesazheve',
    liveAgentLimit: 'Limiti i Agjentëve të Drejtpërdrejtë',
    perMonth: '/muaj',
    agents: 'agjent(ë)',
    messagesAddOn: 'Pako Mesazhesh Shtesore',
    botWhitelabels: 'Botë me Markë të Bardhë',
    totalAddOnMessages: 'Totali i Mesazheve Shtesore',
    basePrice: 'Cmimi Bazë',
    gst: 'GST',
    totalPrice: 'Cmimi Total',
    totalAddOnPrice: 'Cmimi Total i Shtesave',
    whitelabelPrice: 'Cmimi i Markës së Bardhë',
    startedOn: 'Filluar më',
    nextDueOn: 'Vjen më',
    addOnExpiry: 'Skadimi i Shtesave',
    website: 'Uebsajt',
    facebook: 'Facebook',
    telegram: 'Telegram',
  },
  invoice: {
    invoiceNumber: 'Numri i Faturës',
    date: 'Data',
    invoiceAmount: 'Shuma e Faturës',
    planAmount: 'Shuma e Planit',
    plan: 'Plan',
    messages: 'Mesazhet',
    action: 'Veprim',
    nA: 'NA',
    appTooltip: {
      clickToReceiveInvoiceInYourEmailAccount: 'Kliko për të marrë faturën në llogarinë tënde të emailit',
      clickToDownloadInvoice: 'Kliko për të shkarkuar Faturën në formë PDF',
    }
  },
  messageAddOn: {
    validity: 'Vlefshmëria',
    kingPlanHeader: '👑 Plani i Mbretit',
    youAreOnThe: 'Jeni në ',
    asOfNowAndWillGet: 'nga tani, dhe do të merrni ',
    messages: 'mesazhe ',
    inThisPlan: 'në këtë plan. ',
    youCanBuyAdditionalMessaes: 'Mund të blini Mesazhe Shtesore sipas kërkesave të biznesit tuaj.',
    plan: ' Plan',
    baby: 'Bebja',
    king: 'Mbreti',
    get: 'Merr ',
    babyPlan: 'Plani i Bebës ',
    upgradePlan: 'Përmirëso Planin',
    asOfNow: ' nga tani.',
    pleaseUpgradeToKingPlan: 'Ju lutemi, përmirësoni në ',
    toEnableAddOnsAndWhitelabelPacks: ' për të aktivizuar Shtesat dhe Paketët e Markës së Bardhë.',
    messageAddOnPacks: 'Pako Mesazhesh Shtesore',
    ifYouHaveReachedYourMonthlyMessageLimit: 'Nëse keni arritur limitin mujor të mesazheve, blini pako shtesash dhe shijoni shërbimet pa ndërprerje.',
    pleaseSelectNumberOfExpectedMessages: 'Ju lutemi, zgjidhni numrin e pritur të mesazheve',
    addOnsValidity: 'Vlefshmëria e Shtesave',
    currentBillingCycle: 'Cikli i tanishëm i Faturimit',
    oneYear: 'Një Vit',
    summary: 'Përmbledhje',
    messageCreditsWithKingPlan: 'kredite mesazhesh me planin e mbretit',
    messageCreditsWith: 'kredite mesazhesh me ',
    withPlan: '',
    billingCycle: 'Cikli i Faturimit',
    payableAmount: 'Shuma e Pranueshme ',
    oneTimePayment: 'Pagesë një here',
    plusTaxes: ' + Taksa',
    buyNow: 'Bleni Tani',
    whiteLabelChatWindow: 'Dritare Bisede me Markë të Bardhë',
    noBotsLeftToWhiteLabel: 'Nuk ka botë të mbetur për të bërë markë të bardhë.',
    pleaseSelectTheBotsYouWantToWhiteLabel: 'Ju lutemi, zgjidhni botët që dëshironi të bëni markë të bardhë.',
    selectBots: 'Zgjidhni Botët',
    bot: 'Bot',
    bots: 'Botë',
    toBeWhiteLabelled: ' për të bërë Markë të Bardhë',
    remove: 'Hiqe ',
    brandNameFromChatWindow: ' emrin e markës nga dritarja e bisedës.',
    willBeValidTill: 'Do të jetë e vlefshme deri më ',
    ourYearlyPrice: 'Çmimi ynë vjetor ',
    directWhiteLabel: 'Markë e Bardhë Direkte',
    whiteLabelledBots: 'Botët me Markë të Bardhë',
    nextRenewalColon: 'Rinovimi i ardhshëm: ',
    optOutRequested: 'Kërkesë për dalje nga shërbimi',
    contactAgency: 'Kontakto Agjensinë',
    optOut: 'Dalje nga shërbimi',
    removeWhiteLabel: 'Hiqe Markën e Bardhë',
    messageCount: 'Mesazhet',
    numberOfPacks: 'Nr. i Pakove',
    amount: 'Shuma',
    taxes: 'Taksa',
    totalAmount: 'Shuma Totale',
    numOfBots: 'Nr. i Botëve',
    select: 'Zgjidh',
    selectTheValidity: 'Zgjidhni vlefshmërinë',
  },
  payment: {
  },
  paymentMethod: {
    paymentDetails: 'Detajet e Pagesës',
    cardNumber: 'Numri i Kartës ',
    cvv: 'CVV ',
    // cardNumber: 'Numri i Kartës',
    month: 'Muaji',
    year: 'Viti',
    save: 'Ruaj',
    add: 'Shto',
    edit: 'Ndrysho',
    disclaimer: 'Deklaratë: ',
    disclaimerDescription1: 'Detajet e mësipërme të mënyrës së pagesës aplikohen vetëm për përdoruesit jashtë Indisë.',
    disclaimerDescription2: 'Ne nuk ruajmë detajet e kartës suaj te ne. Nëse doni të ndryshoni detajet e kartës suaj, ato do të ndryshohen drejtpërdrejtë me portën e pagesës.',
    billingAddress: 'Adresa e Faturimit',
    companyName: 'Emri i Kompanisë ',
    country: 'Shteti ',
    selectCountry: 'Zgjidhni Shtetin',
    stateOrRegion: 'Shteti/Rajoni ',
    streetAddress: 'Adresa e Rrugës ',
    gstIn: 'GSTIN ',
    postalCode: 'Kodi Postar ',
    cancel: 'Anulo',
    proceedToPay: 'Vazhdo me Pagesën',
    company: 'Kompania',
    state: 'Shteti',
    masterCard: 'Karta Master',
    yourCompanyName: 'Emri i Kompanisë Suaj',
    yourCountry: 'Vendi Juaj',
    yourRegion: 'Rajoni Juaj',
    yourPostalCode: 'Kodi Postar Juaj',
    plusTaxes: ' + taksa',
    dropDown: {
      month: 'Muaji *',
      year: 'Viti *',
    },
    placeholders: {
      enterCardNumber: 'Vendosni numrin e kartës',
      cvv: 'CVV',
      enterYourCompanyName: 'Vendosni emrin e kompanisë suaj',
      enterYourStateOrRegion: 'Vendosni shtetin/rajonin tuaj',
      enterYourStreetAddress: 'Vendosni adresën tuaj të rrugës',
      enterYourGSTIN: 'Vendosni GSTIN tuaj',
      enterPostalCode: 'Vendosni kodin postar',
    }
  },
  plans: {
    viewDetailedPricing: 'Shiko çmimet e detajuara',
    seeHowToUse: 'Shiko si të përdoret',
    help: 'Ndihmë',
    weHaveGotAPricingPlanPerfectForYou: `Kemi një plan çmimesh që është perfekt për ju`,
    weBelieve: 'Ne besojmë ',
    shouldBeAccessibleToAllCompanies: ' duhet të jetë e arritshme për të gjitha kompanitë, pa marrë parasysh madhësinë.',
    monthly: 'Mujor',
    yearly: 'Vjetor',
    twoMonthsFree: '(2 Muaj Falas)',
    babyPlan: 'Plan Bebë',
    freeForever: 'FALAS Përherë',
    messagesPerMonth: 'Mesazhe në muaj',
    currentPlan: 'Plan aktual',
    freePlan: 'Plan FALAS',
    kingPlan: 'Plan Mbreti',
    perYear: 'çdo vit',
    plan: 'plan',
    toThe: ' tek',
    plusTaxes: ' + Taksa',
    perMonth: 'çdo muaj',
    upgradePlan: 'Ndërro Planin',
    changePlan: 'Ndrysho Planin',
    currentlyActive: 'Aktualisht Aktiv',
    emperorPlan: 'Plani Mbretor (Enterprise)',
    sendAsManyMessagesAsYouWant: 'Dërgo sa mesazhe të duash',
    contactUs: 'Na kontaktoni',
    features: 'Funksionalitete',
    areYouSureYouWantToShiftFrom: 'A jeni të sigurtë që doni të kaloni nga',
    messages: 'Mesazhe',
    planQuestionMark: 'plan?',
    downgradeToFreePlan: 'Zbrit nga Plani FALAS',
    goToBabyPlan: 'Shko te Plan Bebë',
    thankYouForChoosingBotPenguin: 'Faleminderit që zgjodhët BotPenguin',
    bots: 'Botë',
    facebookPages: 'Faqe në Facebook',
    teamMember: 'Anëtar i grupit',
    dataStorage: 'Ruajtja e të dhënave',
    conditionalFlow: 'Rryma Kushtore',
    liveChat: 'Biseda e drejtëpërdrejtë',
    bookAppointments: 'Regjistro Takime',
    csvExport: 'Eksportimi CSV',
    emailAndCallSupport: 'Mbështetje me Email dhe Thirrje',
    googleCalendarIntegrations: 'Integrim me Kalendarin e Google',
    zohoCrmIntegrations: 'Integrim me Zoho CRM',
    reportsAndAnalytics: 'Raporte dhe Analiza',
    removeBotPenguinBranding: 'Hiq Markën e BotPenguin',
    oneBot: '1 Botë',
    twoKMessagesPerMonth: '2k mesazhe/muaj',
    oneFacebookPage: '1 Faqe në Facebook',
    oneTeamMember: '1 Anëtar i grupit',
    thirtyDaysOfDataStorage: '30 ditë ruajtje të të dhënave',
    unlimitedBot: 'Botë pa kufi',
    threeTo500kMessagesPerMonth: '3k deri në 500k mesazhe/muaj',
    tenFacebookPages: '10 Faqe në Facebook',
    threeTeamMembers: '3 Anëtarë të grupit',
    nintyDaysOfDataStorage: '90 ditë ruajtje të të dhënave',
    unlimitedMessages: 'Mesazhe pa kufi',
    unlimitedFacebookPages: 'Faqe në Facebook pa kufi',
    unlimitedTeamMembers: 'Anëtarë të grupit pa kufi',
    unlimitedDataStorage: 'Ruajtje e të dhënave pa kufi',
    youAreHere: `Jeni këtu!`,
    detailedPricing: {
      kingsplan: 'Plan Mbreti',
      elementary: 'Elementare',
      solutionType: 'Lloji i zgjidhjes',
      saas: 'SaaS',
      fbpage1fb: '1 Faqe FB',
      perMonth100: '100 në muaj',
      enterprise: 'Enterprise',
      saasOnPremises: 'SaaS në zyrë',
      aiChatbotFeatures: 'Karakteristikat e AI Chatbot',
      dataSourceForTraning: 'Burimi i të dhënave për trajnim',
      smartFeatures: 'Karakteristika inteligjente',
      liveChat: 'Biseda live',
      day30: '30 ditë',
      day90: '90 ditë',
      landSquared: 'Landsquared',
      doItYourself: 'Bëje vetë',
      unifiedInbox: 'Inbox i unifikuar',
      platforms: 'Platforma',
      websiteChatbot: 'Chatbot i faqes së internetit',
      FacebookMessengerChatbot: 'Facebook Messenger Chatbot',
      Telegram: 'Telegram',
      conversationalLandingPage: 'Faqja e nisjes bisedore',
      integrations: 'Integrimet',
      reportsAndAnalytics: 'Raporte dhe Analiza',
      customerSupport: 'Mbështetje ndaj klientëve',
      security: 'Siguria',
      bots: 'Botë',
      babyPlan: 'Plan Bebë',
      kingPlan: 'Plan Mbreti',
      emperorPlan: 'Plan Mbretor',
      noofBots: 'Nr. i botëve',
      one: '1 (Një)',
      unlimitedBots: 'Botë pa kufi',
      noOfWebsite: 'Nr. i faqeve të internetit',
      unlimitedWebsites: 'Faqe të internetit pa kufi',
      unlimitedMessages: 'Mesazhe pa kufi',
      messagesSend: 'Mesazhe të dërguara',
      perMonth2000: '2,000 në muaj',
      upto500000perMonth: 'Deri në 500,000 në muaj',
      facebookMessenger: 'Facebook Messenger',
      unlimitedPages: 'Faqe pa kufi',
      telegramNumbers: 'Numrat e Telegramit',
      unlimited: 'Pa kufi',
      whatsappNumbers: 'Numrat e WhatsApp',
      subscribersLeads: 'Abonentë/Leads',
      createSupportTeam: 'Krijo ekip mbështetjeje për bisedën live',
      oneMember: '1 Anëtar',
      threeMembers: '3 anëtarë',
      conversationHistory: 'Historia e bisedës',
      thirtyDays: '30 ditë',
      ninetyDays: '90 ditë',
      chatbotDesigning: 'Dizajnim i Chatbot',
      weAreHereToHelp: 'Jemi këtu për të ndihmuar',
      weTakeCareEndToEnd: 'Ne kujdesemi nga fillimi deri në fund',
      multipleLanguages: 'Gjuhë të shumta',
      conditionalFlow: 'Rryma kushtore',
      removeBotPenguinBranding: 'Hiq markën e BotPenguin',
      gptMessages: 'Mesazhet GPT',
      aiChatbot: 'AI Chatbot',
      chatGPTIntegration: 'Integrimi i ChatGPT',
      configureAIChatbotPersonality: 'Konfiguro personalitetin e AI Chatbot',
      trainChatbotOnYourOwnData: 'Strehoni Chatbot në të dhënat tuaja',
      trainChatbotOnWebPages: 'Strehoni Chatbot në faqet e internetit',
      trainChatbotOnMultipleFiles: 'Strehoni Chatbot në disa skedarë',
      trainChatbotOnFAQs: 'Strehoni Chatbot në FAQ',
      dataTrainingStorage: 'Ruajtja e të dhënave për trajnim',
      useChatGPTModel4_3_5Turbo: 'Përdorni modelin ChatGPT 4/3.5 turbo',
      uploadMultipleFilesForChatbotTraining: 'Ngarkoni disa skedarë për trajnimin e Chatbot',
      naturalLanguageProcessing: 'Përpunimi i gjuhës natyrore',
      naturalLanguageUnderstanding: 'Kuptimi i gjuhës natyrore',
      answerLength: 'Gjatësia e përgjigjes',
      chatTone: 'Ton i bisedës',
      multiLanguage: 'Multi-Gjuhësor',
      answerFormatting: 'Formatimi i përgjigjes',
      customPrompt: 'Thirrje e personalizuar',
      integrateBotPenguinLLM: 'Integrimi i BotPenguin LLM',
      integrateOwnCustomLLM: 'Integrimi i LLM të personalizuar',
      periodicallySyncDataSources: 'Sinkronizo periodikisht burimet e të dhënave',
      aiBasedSuggestedQuestions: 'Pyetje të sugjeruara nga AI',
      chooseVisibilityForParticularWebpageSitemap: 'Zgjidhni shikueshmërinë për faqen e internetit/specifikimin e hartës së faqes',
      chooseKnowledgeMix: 'Zgjidhni Miksin e njohurive:\nBaza e njohurive juaj\nNjohuria e ChatGPT\n"Njohuria e ChatGPT + Baza e njohurive tuaj"',
      faqExtractionFromFileAndURL: 'Ekstraktimi i pyetjeve nga skedarët dhe URL-ja',
      analyticsToImproveAI: 'Analitika për të përmirësuar AI',
      exportQuestionFlow: 'Eksportoni rrjedhën e pyetjeve',
      sessionManagement: 'Menaxhimi i sesionit',
      collectFeedbackOnChatbotResponses: 'Mbledhë feedback mbi përgjigjet e Chatbot',
      smartAIFollowUpQuestions: 'Pyetje të zgjeruara të menzuara nga AI',
      trainOnYourNotionWorkspaceData: 'Strehoni në të dhënat e hapësirës suaj së Notioni',
      trainOnYoutubeVideo: 'Strehoni në videon e YouTube',
      trainOnCustomVideoUpload: 'Strehoni në ngarkimin e videove të personalizuara',
      rssFeed: 'Ushqim RSS',
      googleDrive: 'Google Drive',
      dropBox: 'DropBox',
      ipAndRegionBlocking: 'Bllokim i IP dhe rajonit',
      emailAndMobileValidation: 'Validimi i Email dhe Mobile',
      appointmentsBooking: 'Rezervime terminesh',
      humanHandover: 'Transferim njerëzor',
      botHandover: 'Transferim i Botit',
      handoverBetweenAgents: 'Transferim midis Agjentëve',
      mobileAppsForAgents: 'Aplikacione mobile për Agjentët',
      roleBasedAccessControls: 'Kontrolle bazuar në rol',
      apiIntegrationOnChatFlows: 'Integrim i API në rrjedhën e bisedës',
      liveChatWidget: 'Widget i Bisedës Live',
      typingIndicator: 'Indikator i shkruarjes',
      liveVisitorsDetails: 'Detajet e vizitorëve live',
      multipleSimultaneousChat: 'Biseda e shumëfishtë e njëkohshme',
      liveTypingView: 'Pamje e shkrimit live',
      ruleBasedChatRouting: 'Rutinim i bisedës bazuar në rregulla',
      chatAutoAssignments: 'Detyrimet automatike të bisedës',
      efficientOmnichannelInterface: 'Ndërfaqe efikase omnichannel',
      quickReplies: 'Përgjigje të shpejta',
      unifiedCustomerProfile: 'Profili i bashkuar i klientit',
      visitorStats: 'Statistikat e vizitorit',
      addContactsFromWhatsapp: 'Shto kontakte nga WhatsApp',
      applyFilterAndSortConversations: 'Apliko filtrat dhe radhit bisedat',
      seeChatLogs: 'Shiko regjistrat e bisedës',
      assignNotesAndChatTags: 'Cakto shënime dhe etiketa bisede',
      directCallsToLeadsWithTwilio: 'Thirrje direkte te klientët (me Twilio)',
      customerSegmentation: 'Segmentimi i klientëve',
      exportLeadsInCSV: 'Eksporto klientët në CSV',
      leadNotificationsByEmail: 'Njoftimet e klientëve në email',
      website: 'Faqja e internetit',
      wordPress: 'WordPress',
      whatsApp: 'WhatsApp',
      facebook: 'Facebook',
      telegram: 'Telegram',
      shopify: 'Shopify',
      autoTriggeringOnMobileDesktop: 'Automatizimi në celular/desktop',
      hideBotOnSpecificPages: 'Fsheh botën në faqet specifike',
      imageSharing: 'Ndarja e imazheve',
      readyToUseChatFlowTemplates: 'Shabllonet e gatshme të rrjedhës së bisedës',
      fileSharing: 'Ndarja e skedarëve',
      customDesignForChatWindow: 'Dizajn i personalizuar për dritaren e bisedës',
      facebookMessengerBot: 'Facebook Messenger Bot',
      facebookSubheading: 'Nënheadingu i Facebook',
      telegramSubheading: 'Nënheadingu i Telegramit',
      conversationalLangdingPageSubheading: 'Nënheadingu i faqes së nisjes bisedore',
      integrationsSubheading: 'Nënheadingu i integrimeve',
      multipleSmartFlows: 'Shumë Rryma të Menzuara',
      dripCampaigns: 'Kampanjat e pikave',
      broadcastFBMessages: 'Mesazhet e transmetuara në Facebook',
      multipleFacebookBotWidgets: 'Shumë widgete të botëve në Facebook',
      facebookAutoReplyOnComments: 'Përgjigje automatike në komente në Facebook',
      facebookECommerce: 'Facebook E-commerce',
      broadcastAnalytics: 'Analitikat e transmetimit',
      telegramMessengerBot: 'Telegram Messenger Bot',
      readyToUseTemplates: 'Shabllonet e gatshme',
      groupBroadcastTelegramMessages: 'Mesazhet e transmetuara në grup në Telegram',
      multipleTelegramBotWidgets: 'Shumë widgete të botëve në Telegram',
      conversationalLandingPageBot: 'Bot i faqes së nisjes bisedore',
      smartReplies: 'Përgjigje të menzuara',
      interactiveAndCustomizableUI: 'UI interaktive dhe e personalizueshme',
      leadManagement: 'Menaxhimi i klientëve potencialë',
      easyToInstallAndShare: 'E lehtë për instalim dhe ndarje',
      agileCRM: 'Agile CRM',
      capsule: 'Capsule',
      insightly: 'Insightly',
      nimble: 'Nimble',
      leadsquared: 'Leadsquared',
      chakra: 'Chakra',
      plivo: 'Plivo',
      helpcrunch: 'Helpcrunch',
      getresponse: 'Getresponse',
      supportbee: 'Supportbee',
      pipeline: 'Pipeline',
      zendesk: 'Zendesk',
      joget: 'Joget',
      firmao: 'Firmao',
      kylas: 'Kylas',
      close: 'Mbyll',
      firstpromoter: 'Firstpromoter',
      zingtree: 'Zingtree',
      liveagent: 'Liveagent',
      ontraport: 'Ontraport',
      frontapp: 'Frontapp',
      webhoper: 'Webhoper',
      engagebay: 'Engagebay',
      helpshift: 'Helpshift',
      copper: 'Copper',
      autopilot: 'Autopilot',
      flowlu: 'Flowlu',
      freshdesk: 'Freshdesk',
      salesflare: 'Salesflare',
      teamgate: 'Teamgate',
      shipway: 'Shipway',
      googleSheets: 'Google Sheets',
      googleCalendar: 'Google Calendar',
      googleAnalytics: 'Google Analytics',
      supportTicketingSystem: 'Sistemi i mbështetjes së biletave',
      zapier: 'Zapier',
      pabbly: 'Pabbly',
      hubSpot: 'HubSpot',
      gitHub: 'GitHub',
      salesforce: 'Salesforce',
      inChatAudioAndVideoCall: 'Thirrje audio dhe video në bisedë (Twilio/Agora)',
      courierTracking: 'Ndjekja e kurirëve',
      emailIntegration: 'Integrimi i emailit',
      webhooks: 'Webhooks',
      schedulers: 'Orarët',
      paymentGateways: 'Gateway të pagesave (Stripe & RazorPay)',
      enterpriseIntegrations: 'Integrimet enterprise',
      customIntegration: 'Integrim i personalizuar',
      shopifyIntegration: 'Integrimi me Shopify',
      totalNumberOfMessages: 'Numri total i mesazheve',
      totalNumberOfLeads: 'Numri total i klientëve potencialë',
      weeklyReportBotwise: 'Raporti javor, sipas botit',
      averageAgentResponeTime: 'Koha mesatare e përgjigjes së agjentit',
      visitorTimingReport: 'Raporti i kohës së vizitorit',
      customerSegmentBasedReports: 'Raportet bazuar në segmentin e klientit',
      tagBasedReports: 'Raportet bazuar në etiketë',
      leadGenerationReport: 'Raporti i gjenerimit të klientëve potencialë',
      supportOnWhatsApp: 'Mbështetje në WhatsApp',
      knowledgeBase: 'Baza e njohurive',
      onboardingAndTraining: 'Onboarding dhe trajnim',
      callAndEmailSupport: 'Mbështetje telefonike dhe me email',
      freeChatbotCreation: 'Krijimi i chatbot-it FALAS',
      customerSuccessOfficer: 'Zyrtari i Suksesit të Klientit',
      secureConnection2048BitSSL: 'Lidhje e sigurt 2048-bit SSL',
      securityAssessment: 'Vlerësimi i sigurisë',
      dataCenterInUSOrEU: 'Qendra e të dhënave në SHBA ose BE',
      twoStepVerification: 'Verifikimi në dy hapa',
      accessRestrictionsBasedOnIPs: 'Kufizimet e hyrjes bazuar në IP',
      onDemandAuditLog: 'Regjistri i auditimit sipas kërkesës',
      bannedVisitorsList: 'Lista e vizitorëve të ndaluar',
      customAPIRate: 'Norma e personalizuar e API',
      trustedDomains: 'Domenet e besueshme',
      mb100: '100 MB',
      gb1: '1 GB',
      codingCurious: 'Kurioz për programim',
    },
    appTooltip: {
      TOOLTIP_BABY_PLAN: 'Planin tonë falas',
      TOOLTIP_KING_PLAN: 'Planin më të njohur tonë',
      TOOLTIP_EMPEROR_PLAN: 'Plan të personalizuar për mesazhe të pakufizuara, të dhëna të pakufizuara, anëtarë ekipi të pakufizuar',
      TOOLTIP_CONTACT_US: 'Na kontaktoni përmes WhatsApp ose email në contact@botpenguin.com për të mësuar më shumë rreth planit tonë të personalizuar',
      TOOLTIP_UPGRADE: 'Përmirëso planin tënd aktual për veçori shtesë',
      TOOLTIP_MONTHLY: 'Zgjidh një cikël pagese mujor',
      TOOLTIP_YEARLY: 'Zgjidh një cikël pagese vjetor për të përfituar nga zbritjet',
    }
  },
  whatsappPlans: {
    goToBabyPlan: 'Shko te Plani Bebë',
    freeForever: 'FALAS Përgjithmonë',
    features: 'Veçoritë',
    currentPlan: 'Plani aktual',
    changePlan: 'Ndrysho Planin',
    currentlyActive: 'Momentalisht Aktiv',
    seeHowToUse: 'Shiko si të përdoret',
    weHaveGotPricingPerfectForYou: `Kemi një plan çmimi që është perfekt për ju`,
    weBelieve: 'Ne besojmë ',
    shouldBeAccessibleToAllCompanies: ' duhet të jetë e arritshme për të gjitha kompanitë, pa marrë parasysh madhësinë.',
    monthly: 'Mujor',
    yearly: 'Vjetor',
    twoMonthsFree: '(2 Muaj FALAS)',
    kingPlan: 'Plan Mbreti',
    perYear: 'për vit',
    perMonth: 'në muaj',
    conversationsPerMonth: 'Biseda në muaj',
    upgradePlan: 'Përmirëso Planin',
    emperorPlan: 'Plani i Mbretit (Enterprise)',
    haveAsManyConversationsAsYouNeed: 'Keni aq biseda sa të keni nevojë',
    contactUs: 'Na kontaktoni',
    metaConversationChargesAreAdditional: 'Tarifat për biseda në Meta janë shtesë dhe paguhen drejtpërdrejt nga ju tek Meta, bazuar në përdorimin tuaj.' +
      'Ne nuk ngarkojmë asnjë tarifë shtesë ose tarifë të lehtësueshme.',
    viewDetailedPricing: 'Shiko Tarifat Detajuar',
    conversationPricingModelUsedByMeta: 'Modeli i Çmimit për Biseda i Përdorur nga Meta',
    whatsappBusinessPlatformConversationsFallInto: 'Bisedat në platformën e Biznesit të WhatsApp ndahen në dy kategori që kanë çmim të ndryshëm',
    userInitiatedConversation: 'Biseda e nisur nga përdoruesi',
    userInitiatedConversationDescription: 'Një bisedë që fillon si përgjigje ndaj një mesazhi të përdoruesit. Kur biznesi përgjigjet në një mesazh të përdoruesit brenda ' +
      'dritares së shërbimit të klientit 24 orësh, atëherë ky mesazh do lidhet me një bisedë të nisur nga përdoruesi.' +
      'Bizneset mund të dërgojnë mesazhe me formë të lirë brenda kësaj dritare 24 orëshe të shërbimit të klientit.',
    businessInitiatedConversation: 'Biseda e nisur nga biznesi',
    businessInitiatedConversationDescription: 'Një bisedë që nis nga një biznes duke dërguar një mesazh të përdoruesit jashtë dritares 24 orëshe' +
      ' të shërbimit të klientit. Mesazhet që nisin një bisedë të nisur nga biznesi do të kërkojnë një shabllon mesazhi.',
    areYouSureYouWantTo: 'A jeni të sigurtë që dëshironi të kaloni nga',
    conversations: ' Biseda ',
    plan: ' plani',
    toThe: ' në',
    metaPricingMarkup: 'Përcaktimi i Çmimit nga Meta',
    numberOfChatFlows: 'Numri i rrjedhëve të bisedës',
    greenTickApplication: 'Aplikimi i shenjës së gjelbër',
    extraPhoneNumberLinking: 'Lidhja e numrit të shtesë telefonit',
    teamMembers: 'Anëtarët e ekipit',
    dataStorage: 'Depozitimi i të dhënave',
    conditionalFlow: 'Rrjedha Kushtore',
    liveChat: 'Biseda Live',
    smartInbox: 'Kuti e Postës së Mençur',
    whatsappTemplates: 'Shabllonet e WhatsApp',
    customerSegments: 'Segmentet e Klientëve',
    broadcastAndDripCampaigns: 'Transmetime dhe Kampanja Drip',
    multipleLanguages: 'Shumë Gjuhë',
    bookAppointments: 'Rezervoni Takime',
    csvContactsExport: 'Eksportimi i kontakteve në CSV',
    googleCalendarIntegrations: 'Integrimi me Kalendarin e Google',
    nativeApplications: '60+ Integrimet Native',
    whatsappSupport: 'Mbështetja në WhatsApp',
    emailAndCallSupport: 'Mbështetje me Email dhe Thirrje',
    customerIntegrations: 'Integrimet e Klientit',
    nlpAndNluCapabilities: 'Kapacitetet e NLP dhe NLU',
    chatGPTBot: 'Boti i ChatGPT',
    customerSuccessOfficer: 'Zyrtari i Suksesit të Klientit',
    noMarkupTransparency: 'Asnjë transparencë e çmimit shtesë',
    upto500kPerMonth: 'Deri në 500,000 në muaj',
    beyond500k: 'Përtej 500,000',
    unlimited: 'Pa kufi',
    unlimitedMessages: 'Mesazhe pa kufi',
    oneTeamMember: '1 Anëtar i Ekipit',
    unlimitedTeamMember: 'Anëtarë të Ekipit të Pakufizuar',
    nintyDaysOfDataStorage: '90 ditë depozitim të të dhënave',
    unlimitedDataStorage: 'Depozitimi i të dhënave pa kufi',
    downgradeToFreePlan: 'Zbritje në Planin FALAS',
    detailedPricing: {
      onDemandAuditLog: 'Regjistrimi i Audios në Kërkesë',
      accessRestrictionsBasedOnIPs: 'Kufizime të Qasjes Bazuar në IP',
      averageAgentResponeTime: 'Koha Mesatare e Përgjigjes së Agjentit',
      perMonth100: '100 në muaj',
      solutionType: 'Lloji i Zgjidhjes',
      saas: 'SaaS',
      saasOnPremises: 'SaaS Në Vend',
      emperorPlan: 'Plani i Mbretit',
      babyPlan: 'Plani i Bebës',
      kingsplan: 'Plani i Mbretërve',
      braodcastsAndDrips: 'Transmetime & Shpërthime',
      thirtyDays: '30 Ditë',
      ninetyDays: '90 Ditë',
      oneMember: '1 Anëtar',
      threeMembers: '3 anëtarë',
      one: '1 (Një)',
      unlimitedMessages: 'Mesazhe pa Kufi',
      unlimitedBots: 'Botët e Pa Kufizuara',
      messagesSend: 'Mesazhe të Dërguara',
      upto500000perMonth: 'Deri në 500,000 në muaj',
      unlimited: 'Pa Kufi',
      onlyAdmin: 'Vetëm Admini',
      mb100: '100 MB',
      gb1: '1 GB',
      doItYourself: 'Bëji Vetë',
      weAreHereToHelp: 'Jemi këtu për të ndihmuar',
      weTakeCareEndToEnd: 'Ne kujdesemi nga fillimi deri në fund',
      numberOfBots: 'Numri i Botëve',
      conversations: 'Bisedat',
      gptMessages: 'Mesazhet GPT',
      whatsappNumbers: 'Numrat WhatsApp',
      subscribersLeads: 'Abonentët/Leads',
      createSupportTeamForLiveChat: 'Krijo Ekip Mbështetje për Bisedat Live',
      conversationHistory: 'Historia e Bisedave',
      chatbotDesigning: 'Dizajnim i Chatbotit',
      multipleLanguages: 'Shumë Gjuhë',
      conditionalFlow: 'Rrjedhë Kushtore',
      whatsappTemplates: 'Shabllonet WhatsApp',
      restartChatFlowTriggers: 'Rihap Shpërthimet e Bisedës',
      multipleWhatsAppWidgets: 'Shumë Widget WhatsApp',
      importWhatsappContacts: 'Importo Kontaktet e WhatsApp',
      whatsappQuickReply: 'Përgjigje e Shpejtë WhatsApp',
      whatsappSmartInbox: 'Kuti e Postës së Mençur WhatsApp',
      whatsappEcommerceCatalogs: 'Tregti Elektronike WhatsApp me Katalogë',
      whatsappBroadcast: 'Transmetim WhatsApp',
      whatsappBroadcastAnalytics: 'Analiza e Transmetimeve WhatsApp',
      dripCampaigns: 'Kampanjat Drip',
      customerSegmentation: 'Segmentimi i Klientit',
      keywordBasedResponse: 'Përgjigje Bazuar në Fjalë Kyçe',
      whatsappShopManagement: 'Menaxhimi i Dyqaneve WhatsApp',
      aiChatbot: 'Chatbot i Inteligjencës Artificiale',
      chatGPTIntegration: 'Integrimi i ChatGPT',
      configureAIChatbotPersonality: 'Konfiguro Personalitetin e Chatbotit të IA',
      trainChatbotOnYourOwnData: 'Trajto Chatbotin me të Dhënat Tua',
      trainChatbotOnWebPages: 'Trajto Chatbotin në Faqet e Internetit',
      trainChatbotOnMultipleFiles: 'Trajto Chatbotin në Shumë Dosje',
      trainChatbotOnFAQs: 'Trajto Chatbotin në Pyetjet e Bëra Së Shpaku',
      dataTrainingStorage: 'Depozitimi i Trajnimit të të Dhënave',
      useChatGPTModel4or35Turbo: 'Përdor Modelin ChatGPT 4/3.5 Turbo',
      uploadMultipleFilesForChatbotTraining: 'Ngarko Shumë Dosje për Trajnimin e Chatbotit',
      naturalLanguageProcessing: 'Procesim i Gjuhës Natyrale',
      naturalLanguageUnderstanding: 'Kuptimi i Gjuhës Natyrale',
      answerLength: 'Gjatësia e Përgjigjes',
      chatTone: 'Ton i Bisedës',
      multiLanguage: 'Shumë Gjuhë',
      answerFormatting: 'Formatimi i Përgjigjes',
      customPrompt: 'Pyetje e Personalizuar',
      whatsAppSessionManagement: 'Menaxhimi i Sesioneve WhatsApp (Inaktivitet dhe Mesazhe për Rifillimin e Rrjedhës)',
      integrateBotPenguinLLM: 'Integro LLM BotPenguin',
      integrateOwnCustomLLM: 'Integro LLM të Veta/Të Personalizuar',
      periodicallySyncDataSources: 'Sinkronizo Periodikisht Burimet e të Dhënave',
      aiBasedSuggestedQuestions: 'Pyetje të Sugjeruara nga AI',
      chooseVisibilityForParticularWebpageSitemap: 'Zgjidh Sjelljen për një Faqe të Veçantë në Hartën e Faqes',
      chooseKnowledgeMix: 'Zgjidh Miksimin e Dijes: Diçka e Diçkaje të ChatGPT "Dija e ChatGPT + Baza e Dijes Tuaj"',
      faqExtractionFromFileAndURL: 'Ekstraktimi i Pyetjeve nga Dosja dhe URL-ja',
      analyticsToImproveAI: 'Analitikat për të Përmirësuar AI',
      exportQuestionFlow: 'Eksporto Fluksin e Pyetjeve',
      collectFeedbackOnChatbotResponses: 'Mblidh Feedback për Përgjigjet e Chatbotit',
      smartAIFollowUpQuestions: 'Pyetje të Mençura/AI në Vazhdim',
      trainOnYourNotionWorkspaceData: 'Trajto në të Dhënat e Hapësirës suaj së Notit',
      trainOnYoutubeVideo: 'Trajto në Videon e YouTube',
      trainOnCustomVideoUpload: 'Trajto në Ngarkimin e Video të Personalizuar',
      rssFeed: 'Pasqyra RSS',
      googleDrive: 'Google Drive',
      dropBox: 'DropBox',
      humanHandover: 'Kaloje Njeriun',
      botHandover: 'Kaloje Botën',
      handoverBetweenAgents: 'Kaloje Mes Agjentëve',
      emailAndMobileValidation: 'Validimi i Email-it dhe Mobil-it',
      mobileAppsForAgents: 'Aplikacionet Mobile për Agjentët',
      appointmentBooking: 'Rezervimi i Takimeve',
      roleBasedAccessControls: 'Kontrollet e Qasjes Bazuar në Rol',
      ruleBasedChatRouting: 'Drejtimi i Bisedës Bazuar në Rregull',
      liveVisitorsDetails: 'Detajet e Vizitorëve Live',
      multipleSimultaneousChats: 'Biseda të Shumëfishta të Ngjashme',
      visitorStats: 'Statistikat e Vizitorëve',
      addContactsFromWhatsApp: 'Shto Kontaktet nga WhatsApp',
      applyFilterAndSortConversations: 'Zbatoni Filtra dhe Renditni Bisedat',
      seeChatLogs: 'Shiko Regjistrat e Bisedave',
      quickReplies: 'Përgjigje të Shpejta',
      unifiedCustomerProfile: 'Profili i Përbashkët i Klientit',
      assignNotesAndChatTags: 'Caktoni Shënime dhe Etiketa Bisedash',
      exportLeadsInCSV: 'Eksporto Përparësitë në CSV',
      tagContacts: 'Etiketo Kontakte',
      customAttributes: 'Atribute të Personalizuara',
      markStatusOfConversations: 'Shënimi i Statusit të Bisedave',
      assignConversationToAgents: 'Cakto Bisedën tek Agjentët',
      leadNotificationsByEmail: 'Njoftimet e Përparësive përmes Email-it',
      directCallsToLeadsWithTwilio: 'Thirrjet Direkte tek Përparësitë (me Twilio)',
      whatsAppTemplates: 'Shabllonet WhatsApp',
      promotionalMessageFrequencyControl: 'Kontrolli i Frekuencës së Mesazheve Promovuese',
      whatsAppWidget: 'Widget WhatsApp',
      whatsAppQR: 'WhatsApp QR',
      whatsAppLink: 'Lidhja WhatsApp',
      campaignScheduler: 'Orari i Kampanjës',
      customTriggers: 'Shpërthime të Personalizuara',
      customCampaigns: 'Kampanja të Personalizuara',
      repeatPurchaseReminders: 'Kujtesë për Përseritje të Blerjes',
      campaignOpenRateTracking: 'Gjurmim i Nivelit të Hapjes së Kampanjës',
      paymentCollectionOnWhatsApp: 'Mbledhja e Pagesave në WhatsApp',
      agileCRM: 'Agile CRM',
      capsule: 'Capsule',
      insightly: 'Insightly',
      nimble: 'Nimble',
      leadsquared: 'Leadsquared',
      chakra: 'Chakra',
      plivo: 'Plivo',
      helpcrunch: 'Helpcrunch',
      getresponse: 'Getresponse',
      supportbee: 'Supportbee',
      pipeline: 'Pipeline',
      zendesk: 'Zendesk',
      joget: 'Joget',
      firmao: 'Firmao',
      kylas: 'Kylas',
      close: 'Mbylle',
      firstpromoter: 'Firstpromoter',
      zingtree: 'Zingtree',
      liveagent: 'Liveagent',
      ontraport: 'Ontraport',
      frontapp: 'Frontapp',
      webhoper: 'Webhoper',
      engagebay: 'Engagebay',
      helpshift: 'Helpshift',
      copper: 'Copper',
      autopilot: 'Autopilot',
      flowlu: 'Flowlu',
      freshdesk: 'Freshdesk',
      salesflare: 'Salesflare',
      teamgate: 'Teamgate',
      shipway: 'Shipway',
      googleSheets: 'Google Sheets',
      googleCalendar: 'Google Calendar',
      googleAnalytics: 'Google Analytics',
      supportTicketingSystem: 'Sistemi i Përkrahjes me Biletat e Ndihmës',
      zapier: 'Zapier',
      pabbly: 'Pabbly',
      hubSpot: 'HubSpot',
      gitHub: 'GitHub',
      salesforce: 'Salesforce',
      inChatAudioAndVideoCall: 'Thirrje Audio dhe Video në Bisedë (Twilio/Agora)',
      courierTracking: 'Gjurmimi i Kurierit',
      emailIntegration: 'Integrimi i Email-it',
      webhooks: 'Webhooks',
      schedulers: 'Planifikuesit',
      paymentGateways: 'Portat e Pagesave (Stripe & RazorPay)',
      enterpriseIntegrations: 'Integrimet Korporatash',
      customIntegration: 'Integrim i Personalizuar',
      freeWhatsAppAPIApprovalAndSetup: 'Miratimi dhe Konfigurimi i WhatsApp API falas',
      developerAPIsAccess: 'Qasja në API-të e Zhvilluesit',
      customRateLimit: 'Kufiri i Normës së Personalizuar',
      totalNumberOfLeads: 'Numri Total i Përparësive',
      averageAgentResponseTime: 'Koha Mjedisore e Përgjigjes së Agjentit',
      visitorTimingReport: 'Raporti i Kohës së Vizitorit',
      customerSegmentBasedReports: 'Raporte Bazuar në Segmentin e Klientit',
      tagBasedReports: 'Raporte Bazuar në Etiketë',
      leadGenerationReport: 'Raporti i Krijimit të Përparësive',
      supportOnWhatsApp: 'Mbështetje në WhatsApp',
      knowledgeBase: 'Baza e Dijes',
      onboardingAndTraining: 'Onboarding dhe Trajnim',
      callAndEmailSupport: 'Mbështetje Telefoni dhe Email',
      freeChatbotCreation: 'Krijimi i Chatbot-it Falas',
      customerSuccessOfficer: 'Zyrtari i Suksesit të Klientit',
      secureConnection: 'Lidhje e Sigurt 2048 bit SSL',
      securityAssessment: 'Vlerësimi i Sigurisë',
      dataCenterLocation: 'Vendndodhja e Qendrës së të Dhënave',
      twoStepVerification: 'Verifikimi në Dy Hapa',
      accessRestrictions: 'Kufizimet e Qasjes',
      auditLog: 'Regjistri i Auditit në Kërkesë',
      bannedVisitorsList: 'Lista e Vizitorëve të Ndaluar',
      customAPIRate: 'Normë e Personalizuar e API',
      trustedDomains: 'Dome të Besueshme',
      elementary: 'Elementare',
      bots: 'Botë',
      unlockWhatsapp: 'Hap WhatsApp',
      aiChatbotFeatures: 'Funksionalitetet e Chatbot-it AI',
      dataSourceForTraining: 'Burimi i të Dhënave për Trajnim',
      smartFeatures: 'Funksionalitetet e Mençur',
      liveChat: 'Bisedë Live',
      smartInbox: 'Kuti e Postës së Mençur',
      broadcastsAndDrips: 'Transmetime & Shpërthime',
      integrations: 'Integrimet',
      development: 'Zhvillimi',
      reportsAndAnalytics: 'Raportet dhe Analitikat',
      customerSupport: 'Mbështetje Klienti',
      security: 'Siguria',
      whatsappWidgets: 'Widget-e WhatsApp',
      campaignSchedular: 'Orari i Kampanjës',
      repeatPurchaseRemainder: 'Rikujtimi i Blerjes së Përsëritur',
      // metaConversationChargesAreAdditional: 'Meta conversation charges are additional and paid directly by you to Meta, based on' +
      //   ' your usage. We do not charge any markup or facilitation fees.',
      // kingPlan: 'King Plan',
      // emperorPlan: 'Emperor Plan',
      // solutionType: 'Solution Type',
      // whatsappTemplates: 'WhatsApp Templates',
      // dripCampaigns: 'Drip campaigns',
      // multipleWhatsappWidgets: 'Multiple WhatsApp Widgets',
      // importWhatsappContacts: 'Import Whatsapp Contacts',
      // whatsappQuickReply: 'WhatsApp Quick reply',
      // whatsappSmartInbox: 'WhatsApp Smart Inbox',
      // whatsappECommerceWithCatalogs: 'WhatsApp E-commerce with Catalogs',
      // whatsappBroadcast: 'WhatsApp Broadcast',
      // whatsappBroadcastAnalytics: 'WhatsApp Broadcast Analytics',
      // customerSegmentation: 'Customer Grouping',
      // keywordBasedResponse: 'Keyword Based Response',
      // nlpBasedTraining: 'NLP Based Training',
      // humanHandOver: 'Human Handover',
      // botHandOver: 'Bot Handover',
      // handOverBetweenAgents: 'Handover between Agents',
      // emailAndMobileValidation: 'Email and Mobile Validation',
      // mobileAppsForAgents: 'Mobile Apps for Agents',
      // appointmentsBooking: 'Appointments Booking',
      // chatGPTIntegration: 'ChatGPT integration',
      // faqTraining: 'FAQ Training',
      // naturalLanguageProcessing: 'Natural Language Processing',
      // naturalLanguageUnderstanding: 'Natural Language Understanding',
      // roleBasedAccessControl: 'Role-based Access Controls',
      // liveVisitorsDetails: 'Live Visitors details',
      // multipleSimultaneousChats: 'Multiple simultanaeous chats',
      // ruleBasedChatRouting: 'Rule based Chat Routing',
      // createSupportTeamForLiveChat: 'Create Support Team for Live chat',
      // visitorStats: 'Visitor stats',
      // addContactsFromWhatsapp: 'Add Contacts from Whatsapp',
      // applyFilterAndSortConversation: 'Apply filter and sort conversations',
      // seeChatLogos: 'See chat logs',
      // directCallToLeads: 'Direct Calls-to-leads (with Twilio)',
      // quickReplies: 'Quick Replies',
      // unifiedCustomerProfile: 'Unified Customer Profile',
      // assignNotesAndChatTags: 'Assign Notes and Chat Tags',
      // exportLeadsInCsv: 'Export Leads in CSV',
      // leadNotificationsByEmail: 'Lead Notifications by email',
      // promotionalMessageFrequencyControl: 'Promotional Message Frequency Control',
      // repeatPurchaseRemainder: 'Repeat Purchase Reminders',
      // whatsappWidgets: 'WhatsApp Widget',
      // whatsappQR: 'WhatsApp QR',
      // whatsappLink: 'WhatsApp Link',
      // campaignSchedular: 'Campaign Scheduler',
      // campaignOpenRateTracking: 'Campaign Open Rate Tracking',
      // customTriggers: 'Custom Triggers',
      // customCampaigns: 'Custom Campaigns',
      // paymentCollectionOnWhatsapp: 'Payment Collection On WhatsApp',
      // zapier: 'Zapier',
      // crmIntegrations: 'CRM Integrations (25+)',
      // supportTicketingSystem: 'Support Ticketing System',
      // googleSheets: 'Google Sheets',
      // inChatAudioAndVideo: 'In-chat audio and video call',
      // googleCalendar: 'Google Calendar',
      // googleAnalytics: 'Google Analytics',
      // emailIntegration: 'Email Integration',
      // courierTracking: 'Courier Tracking',
      // webhooks: 'Webhooks',
      // paymentGateways: 'Payment Gateways',
      // hubspot: 'HubSpot ',
      // gitHub: 'GitHub ',
      // zendesk: 'Zendesk',
      // salesforce: 'Salesforce',
      // customIntegrations: 'Custom Integrations',
      // developerApisAccess: 'Developer APIs access',
      // customRateLimit: 'Custom Rate Limit ',
      // totalNumberOfLeads: 'Total Number of Leads',
      // averageAgentResponseTime: 'Average agent respone time',
      // visitorTimingReport: 'Visitor Timing Report',
      // customerSemgentBasedReport: 'Customer Group-based Reports',
      // tagBasedReport: 'Tag-based Reports',
      // leadGenerationReport: 'Lead Generation Report',
      // supportOnWhatsapp: 'Support on WhatsApp',
      // knowledgeBase: 'Knowledge Base',
      // onboardingAndTraining: 'Onboarding and Training',
      // callAndEmailSupport: 'Call and Email Support',
      // freeChatBotCreation: 'FREE chatbot creation',
      // elementary: 'Elementary',
      // smartFeatures: 'Smart Features',
      // liveChat: 'Live Chat',
      // smartInbox: 'Smart Inbox',
      // broadcastsAndDrips: 'Broadcasts & Drips',
      // integrations: 'Integrations',
      // development: 'Development',
      // reportsAndAnalytics: 'Reports and Analytics',
      // customerSupport: 'Customer Support',
      // unlockWhatsapp: 'Unlock WhatsApp',
      // saas: 'SaaS',
      // saasOnPremises: 'SaaS/On-Premises',
      // customerFaqs: `Custom FAQ's`,
      // oneMember: '1 member',
      // beWhereTheCustomersAre: 'Be where the customers are',
      // lifesEasy: 'Life\'s easy',
      // oneTextAway: 'One text away',
      // everyWhereAtOnce: 'Everywhere at Once',
      // reachOut: 'Reach Out',
      // morePowerToYou: 'More power to you',
      // codingCurious: 'Coding Curious',
      // knowledgeIsPower: 'Knowledge is power',
      // noDoubtsRemain: 'No doubts remain',
    },
    appTooltip: {
      TOOLTIP_BABY_PLAN: 'Planin tonë falas',
      TOOLTIP_KING_PLAN: 'Planin më të njohur tonin',
      TOOLTIP_EMPEROR_PLAN: 'Plan i personalizuar për mesazhe të pakufizuara, të dhëna të pakufizuara, anëtarë ekipi të pakufizuar',
      TOOLTIP_CONTACT_US: 'Na kontaktoni përmes WhatsApp ose email në contact@botpenguin.com për të mësuar më shumë rreth planit tonë të personalizuar',
      TOOLTIP_UPGRADE: 'Përmirëso planin aktual për veçori shtesë',
      TOOLTIP_MONTHLY: 'Zgjidh një cikël pagese mujor',
      TOOLTIP_YEARLY: 'Zgjidh një cikël pagese vjetor për avantazhe zbritje',
    }
  }
};
